mutation DuplicateChatOverlay($chatId: ID!) {
  chat: StreamToolsDuplicateChatOverlay(chatId: $chatId) {
    chatId
    name
    twitchChatChannels
    showTextShadow
    textShadow
    showBadges
    showChannelPills
    usernameFontSize
    usernameLineHeight
    messageFontSize
    messageLineHeight
    messageFontWeight
    usernameFontWeight
    imageScale
    messageColor
    blockedWords
    fontFamily
    youtubeSourceEnabled
    youtubeChatChannels
    chatDelayMs
    width
    height
    orientation
    gridCells
    customSize
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    showYouTubeProfilePictures
    youtubeDelayCheck
    createdAt
  }
}
